import { get } from "@rails/request.js";

export default class ProtectedNoteHandler {
  constructor() {
    this.handleSlashCommand = this.handleSlashCommand.bind(this);
    window.addEventListener("slash-command", this.handleSlashCommand);
  }

  async handleSlashCommand(event) {
    if (event.detail.command !== "protected-note") return;

    const bucketId = event.detail.bucket_id;
    const path = `/buckets/${bucketId}/protected_note/new`;

    // Check if we're in zen mode using the data attribute
    const isZenMode = document.documentElement.hasAttribute("data-zen-mode");

    // Make the request
    await get(path);

    // After the frame is replaced, if we were in zen mode, ensure it stays in zen mode
    if (isZenMode) {
      // Small delay to ensure the new frame is loaded
      requestAnimationFrame(() => {
        document.documentElement.setAttribute("data-zen-mode", "");
      });
    }
  }
}
